<template>
  <v-card height='100%'>
    <v-card-subtitle>{{ $vuetify.lang.t('$vuetify.charts.filters.period.title') }}</v-card-subtitle>
    <v-card-text>
      <v-radio-group v-model="period" row :label="$vuetify.lang.t('$vuetify.charts.filters.period.label')"
                     @change="sendPeriod">
        <v-radio :label="$vuetify.lang.t(`$vuetify.charts.filters.period.${period}`)" :value="period"
                 v-for="period in periods" :key="period"></v-radio>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
const periods = ['minute', 'hour', 'day', 'week', 'month']

export default {
  name: 'periodChartFilter',
  data: () => ({
    period: 'month',
    periods: periods
  }),
  methods: {
    sendPeriod (value) {
      this.$emit('period-changed', value)
    }
  }
}
</script>

<style scoped>

</style>
